import { request } from "services/api/util";

class ProductService {
  async getListProducts(param) {
    const config = {
      method: "get",
      url: `admin/product`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailProduct(id) {
    const config = {
      method: "get",
      url: `admin/product/${id}`,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getProductCategories(body) {
    return request({
      method: "post",
      url: "admin/product/relevantProductCategories",
      data: body,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    });
  }

}

export default new ProductService();
